// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__3VPPL","content":"PrivacyPolicyPage_content__1Ux_F"};